import { fields } from 'state/ducks/facets/types';
import { ISearchDefinition } from 'state/ducks/search/types';
import { IRequest } from '../utils/endpoints/request-helper';

/**
 * Instrument Endpoints
 *   instrument_index                    GET        ANY      ANY    /api/instrument/
 *   instrument_filter                   GET        ANY      ANY    /api/instrument/filter
 *   instrument_recent                   GET        ANY      ANY    /api/instrument/recent
 *   instrument_favorite                 GET        ANY      ANY    /api/instrument/favorite/{id}
 *   instrument_new                      GET|POST   ANY      ANY    /api/instrument/new
 *   instrument_edit                     PUT|POST   ANY      ANY    /api/instrument/{id}/edit
 *   instrument_delete                   DELETE     ANY      ANY    /api/instrument/{id}
 *   instrument_manufacturers            GET        ANY      ANY    /api/instrument/manufacturers
 *   instrument_get                      GET        ANY      ANY    /api/instrument/{id}
 *   instrument_search                   POST       ANY      ANY    /api/instrument/search/{query}
 *   instrument_buckets                  POST       ANY      ANY    /api/instrument/buckets/{field}/{query}
 *
 */

export interface IImage {
  id: string;
  category: string;
  fileName: string;
  filePath: string;
}

export interface IClassOfDetSys {
  id: string;
  label: string;
  description: string;
}

export interface IRecentMessage {
  id: string;
  manufacturer: string;
  model: string;
  variant: string;
  biological: boolean;
  chemical: boolean;
  radNuc: boolean;
  classOfDetectionSystem: IClassOfDetSys[];
  images: IImage[];
}

export const instruments = {
  getAll: (): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrument/`,
    options: {
      method: 'GET',
    },
  }),
  getOne: (id: string): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrument/${id}`,
    options: {
      method: 'GET',
    },
  }),
  getOneSlug: (id: string): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrument/slug/${id}`,
    options: {
      method: 'GET',
    },
  }),
  filter: (): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrument/filter`,
    options: {
      method: 'GET',
    },
  }),
  search: (body: any = {}): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrument/search`,
    options: {
      method: 'POST',
      body: JSON.stringify(body),
    },
  }),
  searchWithQuery: (query: ISearchDefinition): IRequest => ({
    route: () =>
      `${process.env.REACT_APP_API_URI}/api/instrument/search${
        query.text ? `/${query.text}` : ''
      }?maxPerPage=${query.maxPerPage}&currentPage=${query.currentPage}`,
    options: {
      method: 'POST',
      body: JSON.stringify({ filters: query.filters }),
    },
  }),
  buckets: (body: any = {}): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrument/buckets`,
    options: {
      method: 'POST',
      body: JSON.stringify(body),
    },
  }),
  bucketsWithQuery: (query: ISearchDefinition): IRequest => ({
    route: () =>
      `${process.env.REACT_APP_API_URI}/api/instrument/buckets${
        query.text ? `/${query.text}` : ''
      }`,
    options: {
      method: 'POST',
      body: JSON.stringify({
        filters: query.filters,
        fields,
      }),
    },
  }),
  recent: (): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrument/recent`,
    options: {
      method: 'GET',
    },
  }),
  create: (body: any): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrument/new`,
    options: {
      method: 'POST',
      body: JSON.stringify(body),
    },
  }),
  edit: (id: string, body: any): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrument/${id}/edit`,
    options: {
      method: 'PUT',
      body: JSON.stringify(body),
    },
  }),
  delete: (id: string): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrument/${id}`,
    options: {
      method: 'DELETE',
    },
  }),
  uploadFile: (id: string, formData: any): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrument/upload/${id}`,
    options: {
      method: 'POST',
      body: formData,
    },
  }),
  deleteFile: (id: string): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrumentFile/${id}`,
    options: {
      method: 'DELETE',
    },
  }),
  downloadFile: (id: string, path: string): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/instrument/download/${id}?path=${path}`,
    options: {
      method: 'GET',
    },
  }),
};
